import { useEffect, useState } from "react";
import { fetchUserInfo, UserInfoResponse } from "./userGateway";

export interface UserInfoHookResponse {
    loading: boolean;
    error: boolean;
    user: UserInfoResponse;
}

const uninitializedUser: UserInfoResponse = {
    dealerCode: "",
    firstName: "",
    lastName: "",
    loginUrl: "",
    roles: [],
    username: "",
    internalUser: false,
    canAccessContentManagement: false,
    canProvideAfterSalesCare: false,
    canSearchApplications: false,
    canStartNewApplications: false,
    canManageUsers: false,
    canManageAdminUsers: false,
    kerberos: false,
    associatedDealers: [],
    userInfoRetrieved: false
};

function useUserInfo(userInfoEndpoint: string): UserInfoHookResponse {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [user, setUser] = useState(uninitializedUser);

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                const userInfo = await fetchUserInfo(userInfoEndpoint);
                setUser({...userInfo, userInfoRetrieved: true});
            } catch (e) {
                setError(true);
            }
            setLoading(false);
        };
        void fetch();
    }, []);

    return { loading, error, user };
}

export {
    uninitializedUser,
    useUserInfo
};
